export const SHAREPOINT_TAGS = {
  SHAREPOINT_TAG: "Sharepoint",
};
